import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const Categories = () => {
  const { categorys } = useSelector((state) => state.home);
  return (
    <div className="w-full">
      <SEO
        title="Categories"
        description="Browse our product categories on Apna Plaza."
      />
      <Headers />
      {/* Page Header */}
      <div className="bg-card py-11 border-b border-primaryLighter">
        <div className="w-full">
          <div className="flex flex-col justify-center items-start container mx-auto">
            <div className="flex justify-center items-center gap-3 mb-1.5 text-sm font-medium text-secondary">
              <span className="hover:text-primary cursor-pointer transition-colors">
                Home
              </span>
              <span className="text-primary">/</span>
              <span className="text-primary">Categories</span>
            </div>
            <h2 className="text-4xl font-medium text-primary mb-2">
              ALL CATEGORIES
            </h2>
            <p className="text-base">
              Explore our wide range of product categories
            </p>
          </div>
        </div>
      </div>
      <section className="py-14 lg:py-10">
        <div className="w-[85%] md:w-[90%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="w-full grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
            {categorys.map((c, i) => (
              <Link
                to={`/products?category=${c.name}`}
                key={i}
                className="hover:border hover:border-secondary/20 group transition-all duration-300 hover:bg-card rounded-3xl hover:shadow-sm hover:-mt-1 bg-white p-4 flex flex-col items-center justify-center gap-4"
              >
                <img
                  src={c.image}
                  className="w-[100px] h-[100px] rounded-full overflow-hidden object-cover"
                  alt={c.name}
                />
                <h2 className="text-lg font-medium text-primary">{c.name}</h2>
                <IoIosArrowForward className="text-secondary group-hover:text-primary transition-colors" />
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Categories;
